import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { mongoose, Prop, Severity } from '@typegoose/typegoose'
import GraphQLJSON from 'graphql-type-json'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('StateTransitionInput')
export class StateTransition {
  @Field(() => ID)
  @Prop({ index: true, type: String, default: () => generateEntityId('sttr') })
  _id: string

  @Field(() => Date)
  @Prop({ type: Date, default: () => new Date() })
  updatedAt: Date

  @Field(() => String)
  @Prop({ type: String })
  state: string

  @Field(() => GraphQLJSON)
  @Prop({ type: mongoose.Schema.Types.Mixed, allowMixed: Severity.ALLOW })
  entity: Record<any, any>

  @Field(() => GraphQLJSON)
  @Prop({ type: mongoose.Schema.Types.Mixed, allowMixed: Severity.ALLOW })
  args: Record<any, any>
}
